module.exports = __webpack_public_path__ + "static/media/Superior.1.19e8b7bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/superior/images/Superior.1.jpg
// module id = 690
// module chunks = 0